import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BaseOverviewLoader } from '../overview-base/overview-base';
import { P2000Melding } from 'src/app/models/p2000.model';

@Component({
    selector: 'app-overview-112',
    templateUrl: './overview-112.component.html',
    styleUrls: ['./overview-112.component.scss'],
    standalone: false
})
export class Overview112Component extends BaseOverviewLoader implements OnInit, OnDestroy {
  isMobileView: boolean;
  hasScrolled: boolean = false;
  pageTitle: string = '112';
  showLocationFeatures: boolean = false;
  selectedRegion: string = '';

  @HostListener("window:scroll", []) onScroll(): void {
    this.hasScrolled = window.pageYOffset > 0;
  }

  readonly destroy$: Subject<Boolean> = new Subject();

  ngOnInit(): void {
    super.ngOnInit();

    this.deviceService.isMobileView.pipe(
      takeUntil(
        this.destroy$
      )).subscribe((data: boolean) => {
        this.isMobileView = data;
      });

    this.selectedRegion = this.p2000Service.selectedRegion;

    this.activeRoute.queryParams.pipe(
      takeUntil(
        this.destroy$
      )).subscribe(params => {
        if (!!params.regio) {
          this.selectedRegion = params.regio;

          if (!!this.selectedRegion) {
            this.p2000Service.selectedRegion = this.selectedRegion;
          }
        }
      });

    this.loadNewRegion();
  }

  pushGoogleAds() {
    if(!this.displayAds) return;

    setTimeout(() => {
      try {
        this.all112Events.forEach((event: P2000Melding, index) => {
          if (index % 5 === 0 && index > 0) {
            (window["adsbygoogle"] = window["adsbygoogle"] || []).push({});
          }
        });
      } catch (e) {
        console.error("ads", e);
      }
    }, 900);
  }

  loadNewRegion(): void {
    if (!this.selectedRegion) {
      this.loading = false;
      return;
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.activeRoute,
        queryParams: { regio: this.selectedRegion },
        queryParamsHandling: 'merge'
      });

    this.loading = true;

    this.loadAdsAnd112Alerts(this.selectedRegion).then(() => {
      this.pushGoogleAds();
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
